import { url2link } from '@/js/_common';

const main = () => {
    if (document.querySelector('#page-profile') == null) return;
    // URLをリンクタグに置き換え
    url2link('.p-profile__text');
}

export default main;
